import { Easing, useCurrentFrame, useVideoConfig } from 'remotion';

// Constants
import { WAVE_ANIMATION, WAVE_BAND } from '../../constants';

export const WaveBandsAnimation = () => {
  const frame = useCurrentFrame();
  const { width } = useVideoConfig();

  const { drawDuration } = WAVE_BAND;

  // Bands start after wave slide-in completes
  const elapsed = frame - WAVE_ANIMATION.duration;

  if (elapsed < 0) return null;

  // Phase 1: initial draw-in. Phase 2+: ping-pong cycles
  const cycleDuration = drawDuration * 2;

  let progress: number;

  if (elapsed < drawDuration) {
    progress = Easing.out(Easing.cubic)(elapsed / drawDuration);
  } else {
    // Ping-pong: reverse then forward, repeating
    const loopFrame = (elapsed - drawDuration) % cycleDuration;
    const isReversing = loopFrame < drawDuration;

    progress = isReversing
      ? Easing.out(Easing.cubic)((drawDuration - loopFrame) / drawDuration)
      : Easing.out(Easing.cubic)((loopFrame - drawDuration) / drawDuration);
  }

  const clipWidth = progress * width;

  return (
    <svg
      className="absolute inset-0 w-full h-full"
      viewBox={`0 0 ${width} 1080`}
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        {/* Band 1: grows from left edge */}
        <clipPath id="firstBandClip">
          <rect x={0} y={600} width={clipWidth} height={500} />
        </clipPath>

        {/* Band 2: grows from right edge */}
        <clipPath id="secondBandClip">
          <rect x={width - clipWidth} y={600} width={clipWidth} height={600} />
        </clipPath>
      </defs>

      <path
        d={WAVE_BAND.paths.back}
        fill={WAVE_BAND.color}
        clipPath="url(#secondBandClip)"
        className="opacity-70"
      />
      <path
        d={WAVE_BAND.paths.front}
        fill={WAVE_BAND.color}
        clipPath="url(#firstBandClip)"
        className="opacity-30"
      />
    </svg>
  );
};
